module.exports = __webpack_public_path__ + "img/app-icon-3.26a30bfc.png";